import { useContext, useState } from 'react'
import {useHistory} from "react-router-dom";
import MiniApplet from './autofirma.esm.js';
import {properties, paths, texts, tipoFirma} from 'AppData';
import sha256 from 'crypto-js/sha256';
import {loadState, saveState} from 'providers/localStorage'
import {localStorageNameHistorical} from 'providers/localStorageDataHistorical';
import { localStorageName } from 'providers/localStorageData';
import { properties as propertiesCloudConfig } from 'config/Config';
import AppContext from 'AppContext';
import RestProvider from 'providers/RestProvider' ;
import AuthProvider from 'providers/authProvider';
import { useDispatch, useSelector } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';


/**
 * @ Firma
 * Firma del hash de un 'documento'
 * mediante la librería MiniApplet
 */

const useApp = (setMsgError, handleLoanding, isLoginFromHeader) => {
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);

    ////////////////////////////////Hooks para controlar los mensajes
    let _ID = 0;
    const [message, setMessage] = useState({ msg: '', severity: '' });
    const addAlert = msg => setAlerts([...alerts, { id: _ID++, msg }]);
    const [alerts, setAlerts] = useState([]);
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }
    const dispatch = useDispatch();

    const msgError = {
        severity: 'Error',
        error: 'Ha ocurrido un error al intentar recuperar los datos.',
        formularioNotFound: 'No existe configuración de formulario para la'
    }

    const history = useHistory();
    const contexto = useContext(AppContext)
    const {crudOperation, crudOperationsType} = RestProvider();
    const {login} = AuthProvider();
    let hash64 = null;

    const firmar = () => {
        localStorage.setItem(localStorageName.popUp,true);
		let hash;
        let documento = properties.TEXTO_DOCUMENTO;

        handleLoanding(true);
    
        MiniApplet.setLocale(properties.MINIAPPLET_LOCALE);
        MiniApplet.cargarMiniAppletJA();
    
        hash = sha256(documento).toString();
        hash64 = MiniApplet.getBase64FromText(hash);

        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_CAT_VALOR, { url: properties.COD_PRUEBAS_CARGA, method: properties.CRUD_TYPE_GET}).then(response => {    
            if(response.data.descripcionValor === 'true'){
                successCallBack(properties.MOCK_FIRMA64_99999999R);
            }else{
                MiniApplet.sign(hash64, properties.MINIAPPLET_ALGORITHM, properties.MINIAPPLET_FORMAT, null, successCallBack, errorCallBack)
            }

        }).catch(function (error) {
            MiniApplet.sign(hash64, properties.MINIAPPLET_ALGORITHM, properties.MINIAPPLET_FORMAT, null, successCallBack, errorCallBack)
        })
        .finally(() => {
          handleLoanding(false);
        });     
    }
    
    /**
     * Método que se ejecuta cuando MiniApplet.sing
     * firma de forma correcta
     */
    const successCallBack = (signatureBase64, certificate864) => {
        let afirmaVerifyInput = {
            firmaBase64 : signatureBase64,
            hashDocumentoBase64 : hash64,
        }

        handleLoanding(true);

        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: properties.URL_AFIRMA_VERIFY, method: properties.CRUD_TYPE_POST, data: afirmaVerifyInput}).then(response => {
            login('ciudadano', '', false);
            addToContext(response.data)
            }).catch(function (error) {
                handleLoanding(false);
                let msg = error.response ? error.response.data.messageDescription : texts.ERROR_FIRMA
                if(msg=== undefined){
                  msg = texts.ERROR_FIRMA
                }
                setMsgError(msg, properties.ERROR_SEVERITY);
              })
    
        
    }
    
    /**
     * Método que se ejecuta cuando MiniApplet.sing
     * falla al firmar
     */
    const errorCallBack = (type, message) => {
        handleLoanding(false);
        setMsgError(message, properties.ERROR_SEVERITY);
    }
    
    /*
    *
    */
    const addToContext = (data) =>{

        let usuario = {
            "interesadoNif": data.nifResponsable.toUpperCase(),
            "interesadoNombre": data.nombreResponsable,
            "interesadoApellido1": data.primerApellidoResponsable,
            "interesadoApellido2" : data.segundoApellidoResponsable,
            "tipoAutenticacion" : properties.TIPO_AUTENTICACION_CERTIFICADO,
            "entidadCif" : data.cifEntidad,
            "entidadNombre" : data.razonSocial,
            "datosCertificado" : data.datosCertificado
        }
        
        dispatch(insertNewState({filnedName: 'infoUsuario', value: usuario}));
        handleLoanding(false);

        if(isLoginFromHeader){
            saveState(localStorageName.redirect, properties.REDIRECT_FROM_HEADER, false);
            contexto.updateSesion(properties.SESION_INICIO);
            history.push(paths.HOME);
        }else{
            saveState(localStorageName.redirect, properties.REDIRECT_FROM, false);
            contexto.updateSesion(properties.SESION_INICIO);
        }  
    }

    const loginClave = (mapping) => {

        let host = propertiesCloudConfig['CECEU_CLAVE_SERVER'];
        let resource = properties.RESOURCE_CLAVE;

        window.location.href = host +  '/' + resource + '/' + mapping;

        return false;
    }

    const firmarGenerico = (documento, successCallBack, errorCallBack, procedenciaConvocatoria) => {
        
        let doc = null;
        MiniApplet.setLocale(properties.MINIAPPLET_LOCALE);
        MiniApplet.cargarMiniAppletJA();

        if (procedenciaConvocatoria === 'PCT2') {
            let hash = sha256(documento).toString();
            doc = MiniApplet.getBase64FromText(hash);
        } else {
            doc = (documento.includes('base64,'))
                ? documento.split("base64,")[1]
                : documento; 
        }

        MiniApplet.sign(doc, properties.MINIAPPLET_ALGORITHM, properties.MINIAPPLET_FORMAT, null, successCallBack, errorCallBack);
        return doc;
    }

    const firmaGenericaMasiva = (documentos, callbackMultifirmaOk, callbackMultifirmaKo, procedenciaConvocatoria) => {
        let operationArray = [];
        let dataArray = [];
        let originalDataArray = [];

        if(documentos){
            let length = documentos.length;

            MiniApplet.setLocale(properties.MINIAPPLET_LOCALE);
            MiniApplet.cargarMiniAppletJA();
    
            documentos.forEach((documento) => {
                let doc = null;

                if (procedenciaConvocatoria === 'PCT2') {
                    let hash = sha256(documento).toString();
                    doc = MiniApplet.getBase64FromText(hash);
                } else {
                    doc = (documento.includes('base64,'))
                        ? documento.split("base64,")[1]
                        : documento;                
                }

                operationArray.push('sign');
                originalDataArray.push('');
                dataArray.push(doc);
            });
            
            MiniApplet.multiModeSign(operationArray, dataArray, originalDataArray, length, properties.MINIAPPLET_ALGORITHM,
                properties.MINIAPPLET_FORMAT, null, callbackMultifirmaOk, callbackMultifirmaKo);
        }     
    }

    const calcularHashBase64 = (documento) => {
        let hash = sha256(documento).toString();
        let hash64 = MiniApplet.getBase64FromText(hash);
        return hash64;
    }

    const calcularDataSource = (codApp) => {
        let dataSource = null;

        codApp === properties.codigoAplicacionF2 && (dataSource = properties.F2);
        codApp === properties.codigoAplicacionSUB && (dataSource = properties.SUB);

        return dataSource;
    }

    const quitarTildes = (string) => {
        return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");    
    }

    /**
     * @constant obtenerCodigosFaseEstado Función que obtiene el código de una fase o un estado
     * @param {*} idConvo Id de la convocatoria actual
     * @param {*} nomConst Array con los nombres de las constantes (fase o estado) que se quiera obtener el código
     * Las constantes se configuran en el apartado en referencia a la OV3 en el tramitador
     */
    const obtenerCodigosFaseEstado = async (idConvo, nomConst) => {
        let res = null;
        let dto = {
            idConvocatoria: idConvo,
            nombresConstantes: nomConst
        };

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FASES_ESTADOS_CONVO_OV3, { url: properties.URL_FIND_BY_CODIGO, method: 'post', data: dto}).then(response => {
            res = response.data;
        }).catch(function (error) {
            handleSetMessage(msgError.error, msgError.severity);
        });
        return res;
    }

    /**
     * @function obtenerTipoFirma Función encargada de obtener el tipo de firma que se realizará en el proceso de entrega
     */
    const obtenerTipoFirma = () => {
        let res = tipoFirma.FIRMA_SIMPLE;
        if  (infoUsuario.tipoAutenticacion !== undefined && infoUsuario.tipoAutenticacion !== '') {
            res = (convocatoriaSeleccionada.firmaSms && infoUsuario.tipoAutenticacion === 'ur') ? tipoFirma.FIRMA_SMS : tipoFirma.FIRMA_SIMPLE;
        }

        return res;
    }
   
    /* @function deleteCacheLocalStorage Función encargada de comprobar si existen valores almacenados en el localStorage.
     * En caso de que se obtengan, se procede a su eliminación.
     * Esta comprobación se realiza debido a que pudieran quedar valores almacenados en el localStorage anteriores a la realización de la migración
     * al estado global de redux.
     */
    const deleteCacheLocalStorage = () => {
        
        // Se recorren los valores, se comprueba si existen y si existen se eliminan.
        for (const key in localStorageNameHistorical) {
            let valorObtenido = loadState(localStorageNameHistorical[key]);
            if (valorObtenido !== undefined) {
                localStorage.removeItem(localStorageNameHistorical[key]);
            }
        }
    }
    
    return { firmar, loginClave, firmarGenerico, calcularDataSource, calcularHashBase64, firmaGenericaMasiva, quitarTildes, obtenerCodigosFaseEstado, deleteCacheLocalStorage, obtenerTipoFirma };
}

export default useApp;


